import React from "react";
import ComparisonChildChartComponent from "../components/child/1_ComparisonChildChartComponent";
import MasterLayout from "../masterLayout/MasterLayout";

const ChildComparisonPage = () => {
  return (
    <div>
      <MasterLayout>
        {/* Breadcrumb */}
        {/* <Breadcrumb title="Home" /> */}

        {/* DashBoardLayerOne */}
        <ComparisonChildChartComponent />
      </MasterLayout>
    </div>
  );
};

export default ChildComparisonPage;
